module.exports = __webpack_public_path__ + "img/bab1t1.de601f9c.png";